import { Tags as TagsIcon, UserCheck, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

export interface SelecaoEmLoteProps {
  quantidade: number;
  /** Quantos recebem tags: os próprios (o processo de colega só o Gestor seleciona, para distribuir). */
  quantidadeDeTags?: number;
  onAplicarTags: () => void;
  /** "Distribuir" (§19): só para o Gestor. */
  onDistribuir?: () => void;
  onLimpar: () => void;
}

/**
 * O que se faz com os processos marcados (PLANO_TAGS D13), na linha dos filtros, logo
 * depois de "Tags" (`selecao` da `BarraDaLista`). Lá ele aparece sem empurrar a lista:
 * numa faixa própria em cima da tabela, a tela pulava uma linha ao marcar o primeiro.
 */
export function SelecaoEmLote({
  quantidade,
  quantidadeDeTags = quantidade,
  onAplicarTags,
  onDistribuir,
  onLimpar,
}: SelecaoEmLoteProps) {
  if (quantidade === 0) return null;
  return (
    <div className="flex items-center gap-1" role="region" aria-label="Seleção">
      {quantidadeDeTags > 0 && (
        <Button className="h-11 sm:h-9" onClick={onAplicarTags}>
          <TagsIcon className="mr-2 h-4 w-4" aria-hidden />
          Tags em lote
          <span className="ml-1.5 rounded bg-primary-foreground/20 px-1.5 text-xs tabular-nums">
            {quantidadeDeTags}
          </span>
        </Button>
      )}
      {onDistribuir && (
        <Button variant="outline" className="h-11 sm:h-9" onClick={onDistribuir}>
          <UserCheck className="mr-2 h-4 w-4" aria-hidden />
          Distribuir
          <span className="ml-1.5 rounded bg-muted px-1.5 text-xs tabular-nums">{quantidade}</span>
        </Button>
      )}
      <Button
        variant="ghost"
        size="icon"
        className="h-11 w-11 shrink-0 sm:h-9 sm:w-9"
        onClick={onLimpar}
        aria-label={`Limpar seleção (${quantidade} ${quantidade === 1 ? 'selecionado' : 'selecionados'})`}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
